
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'

const Section = ({ title, children }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      sx={{
        fontSize: 14,
        fontWeight: 600,
        mb: 1,
        color: '#1A1A1A',
      }}>
      {title}
    </Typography>

    <Box
      sx={{
        border: '1px solid #98B6BE',
        borderRadius: 1,
        backgroundColor: '#FFFFFF',
        px: 2,
        py: 1.5,
      }}>
      {children}
    </Box>
  </Box>
)

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Section
